import React from 'react';

import PropTypes from 'prop-types';

import Skeleton from '@asteria/component-core/skeleton';

import Chip from '@asteria/component-chip';

/**
 * @typedef { import('../../../basic/types').Props } Props
 * @typedef { import('../../../basic/types').ChildrenProps } ChildrenProps
 */

/** @type { React.FC<{ currency: string, loading: boolean, onClick: import('react').MouseEventHandler, active: boolean }> } */
const CurrencyChip = React.memo(function CurrencyChip(props) {
	const { currency, loading, onClick, active } = props;

	if (loading) {
		return <Chip label={<Skeleton className="w-10" />} />;
	}

	return (
		<Chip
			label={currency}
			flag={currency}
			onClick={onClick}
			active={active}
		/>
	);
});

CurrencyChip.propTypes = {
	currency: PropTypes.string,
	loading: PropTypes.bool,
	onClick: PropTypes.func,
	active: PropTypes.bool,
};

export default CurrencyChip;
